export const ANN_STATUS = {
  UNPUBLISHED: 0,
  ANNOUNCING: 1,
  DELETED: 2,
  CREATING: 3,
  PENDING_ADJUSTMENT: 4,
  EXPIRED: 5,
  RESERVED: 6
}
